import {Injectable} from '@angular/core';
import {StreamingHttpService} from '@api/http/streaming/streaming-http.service';
import {PickerItem, PickerItemType} from '@lib-modules/picker/components/picker-item/picker-item.component';
import {NewsHttpService, NewsTargetType} from '@api/http/news/news-http.service';
import {INewsPost} from '@api/models/news/news';
import {SportTypeService} from '@api/services/sport-type/sport-type.service';
import {SportType} from '@lib/models/sport-type/sport-type';
import {BaseCardService} from '@lib-modules/cards/services/base-card/base-card.service';

export enum NewsContentType {
  TopNews = 'top_news',
  EntityNews = 'entity_news',
  VideoNews = 'video_news',
}

@Injectable({
  providedIn: 'root'
})
export class NewsCardService extends BaseCardService {
  constructor(
    private streamingHttp: StreamingHttpService,
    private newsHttp: NewsHttpService
  ) {
    super();
  }

  // News
  public async fetchData(
    contentType: NewsContentType,
    item?: PickerItem,
    skip = 0,
    limit = 12,
    queryParams: any = {},
  ): Promise<INewsPost[]> {
    this.init(skip, limit, item, queryParams);

    switch (contentType) {
      case NewsContentType.TopNews:
        return this.getTopNews();
      case NewsContentType.EntityNews:
        return this.getNewsForTarget();
      case NewsContentType.VideoNews:
        return this.getVideoNews();
    }
  }

  private async getTopNews(): Promise<INewsPost[]> {
    if (this.type === PickerItemType.State) {
     const response = await this.newsHttp.getStateTopNews(this.id, this.limit);
     return response?.data || [];
    }
    return await this.newsHttp.getTopNews(this.limit);
  }

  private async getNewsForTarget(): Promise<INewsPost[]> {
    const response = await this.newsHttp.getNewsForTarget(this.newsTargetType, this.id, this.skip, this.limit, this.queryParams);
    return response?.data || [];
  }

  private async getVideoNews(): Promise<INewsPost[]> {
    const response = SportTypeService.selectedSportType === SportType.Football
      ? await this.streamingHttp.getVideoNews(this.skip, this.limit, this.queryParams)
      : await this.newsHttp.getNewsWithLivestreams(this.skip, this.limit);
    return response?.data || [];
  }

  private get newsTargetType(): NewsTargetType {
    switch (this.type) {
      case PickerItemType.Team:
        return NewsTargetType.Team;
      case PickerItemType.League:
        return NewsTargetType.League;
      case PickerItemType.State:
        return NewsTargetType.State;
    }
  }
}
